import { DynamicGalleryEnvService } from '../env';
import { RecordViewMode } from '../model';
import { BaseRouting } from '@aipb/routing';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DynamicGalleryRouting extends BaseRouting {
  static APP_ROUTE = 'dynamic-gallery';
  static configPath = ':configId';

  private _default: string[] = [];

  constructor(dynamicGalleryEnv: DynamicGalleryEnvService) {
    super(['/' + DynamicGalleryRouting.APP_ROUTE, DynamicGalleryRouting.configPath], dynamicGalleryEnv);
  }

  public default(url: string, configId: string = this.getConfigId()): void {
    this.nav(
      this._default,
      {
        configId
      },
      {
        queryParams: {
          url: url
        },
        queryParamsHandling: 'merge'
      }
    );
  }

  public defaultRouteUrl(configId: string = this.getConfigId()): string {
    return this.routeUrl(this._default, {
      configId
    });
  }

  public defaultAbsUrl(url: string, mode: RecordViewMode, configId: string = this.getConfigId()): string {
    return this.absUrl(
      this._default,
      {
        configId
      },
      {
        url,
        mode
      }
    );
  }
}
